'use strict';

angular.module('cvsApp')
  .controller('PaymentMethodsCtrl', ["$scope", "$rootScope", "$timeout", "$state", '$stateParams', "userSession","addDataService","userSession","webAnalytics","loggerService","loggerServiceHelper", "accountDataService",
    function ($scope, $rootScope, $timeout, $state, $stateParams, UserSession,addDataService,userSession,webAnalytics,loggerService,loggerServiceHelper, AccountDataSvc) {
      var log = loggerService(loggerServiceHelper.setCategory(CVSLOGHELPER.CATEGORY.PAYMENT_REGISTERED)+loggerServiceHelper.setFlowType(UserSession.paymentType)+loggerServiceHelper.setFlow("SelectPaymentMethod"));
      log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD)+loggerServiceHelper.setStep(CVSLOGHELPER.STEP.START));
      /*Scroll to top*/
      cvsUtility.genralPostMessage("SCROLL_TO", {"scroll":true});
      // $scope.stateParams  = localStorage.getItem('stateParams') ? JSON.parse(localStorage.getItem('stateParams')) : $stateParams;
      // localStorage.removeItem('stateParams');
      //cvsUtility.resetSessoinTimeOut();
      /**
      * sankar 11/22/2016 - ITPR017031 -  select payment methods
      * Added WTS pagename tag
      * Yogi 03/27/2020 - GST-166
      */

        if ($rootScope.customelementsPayments == true) {
          var utagObj = {};
          utagObj.page_name = 'srx: manage payment methods';
          utagObj.adobe_page_name = 'cvssp' + '|' + cvsUtility.getPlatform() + '|' + utagObj.page_name;
          utagObj.page_category = 'payments';
          webAnalytics.webTrendsUtag("OBJ", utagObj, undefined);
        } else {
          var utagObj = {};
          utagObj.page_name = 'srx: select a payment';
          utagObj.adobe_page_name = 'cvssp' + '|' + cvsUtility.getPlatform() + '|' + utagObj.page_name;
          utagObj.page_category = 'payments';
          webAnalytics.webTrendsUtag("OBJ", utagObj, undefined);
        }
	

        $scope.content = wcmContent;
        $scope.hasExpiredMOP = UserSession.accountData && UserSession.accountData.hasExpiredMOP;
        $scope.successUpdateMessage = false;
        $scope.successCardAddMessage = false;
        $scope.expiredMop = false;
        $scope.successBankAccUpdateMessage = false;
        var formData = angular.copy($scope.session.accountData.getMopById($scope.session.updateCardResult));
        if($rootScope.isCardUpdateSuccess){
          $scope.successUpdateMessage = true;
          
          setTimeout(function () { 
            document.getElementById('paymentInlineAlert').focus(); 
            document.getElementById('paymentInlineAlert').scrollIntoView({ behavior: 'smooth' }); }, 
          100);
      
          $rootScope.isCardUpdateSuccess = false;
        }
        if($rootScope.isCardAddSuccess){
          $scope.successCardAddMessage = true;
          
          setTimeout(function () { 
            document.getElementById('cardAddSuccessBlock').focus(); 
            document.getElementById('cardAddSuccessBlock').scrollIntoView({ behavior: 'smooth' }); }, 
          100);
      
          $rootScope.isCardAddSuccess = false;

          var cardType = getCardType($rootScope.addedCardDetails.mopType);
          
          $scope.successCardAddAlertMessage = cardType+" ending in <strong>"+$rootScope.addedCardDetails.accountNumber+"</strong> has been added to your account successfully.";
          $rootScope.addedCardDetails = {};
        }
      if ($rootScope.isBankAccountUpdateSuccess){
        $scope.successBankAccUpdateMessage = true;

        setTimeout(function () {
          document.getElementById('paymentInlineAlert').focus();
          document.getElementById('paymentInlineAlert').scrollIntoView({ behavior: 'smooth' });
        },
          100);

        $rootScope.isBankAccountUpdateSuccess = false;
      }

      function getCardType(mopType){
          var cardType = '';

          switch(mopType){
            case "VISA" : {
              cardType = '<span class="alert-banner-img"><img src="../payments/app/images/visa_small.svg" alt=""/></span><span class="pl-6">VISA</span>';
              break;
            }
            case "DISCOVER" : {
              cardType = '<span class="alert-banner-img"><img src="../payments/app/images/discover_small.svg" alt=""/></span><span class="pl-6">Discover</span>';
              break;
            }
            case "MASTERCARD" : {
              cardType = '<span class="alert-banner-img"><img src="../payments/app/images/mc_small.svg" alt=""/> </span><span class="pl-6">Mastercard</span>';
              break;
            }
            case "AMERICAN EXPRESS" : {
              cardType = '<span class="alert-banner-img"><img src="../payments/app/images/amex_small.svg" alt=""/></span><span class="pl-6">American Express</span>';
              break;
            }
            case "DINERS CLUB" : {
              cardType = '<span class="alert-banner-img"><img src="../payments/app/images/dinersclub_small.svg" alt=""/></span><span class="pl-6">Diners Club</span>';
              break;
            }
            default : {
              cardType = '<span class="alert-banner-img"><img src="../payments/app/images/bank_small.svg" alt=""/></span><span class="pl-6">Bank account</span>';
              break;
            }
          }

          return cardType;
      }
       
    if($stateParams.paymenttype){
      UserSession.paymentType = $stateParams.paymenttype;
    }

    $scope.guest = {};

    $scope.guest.mopType = userSession.persit["__scopePersist_guest.mopType"] ? userSession.persit["__scopePersist_guest.mopType"] : undefined;//"CHECK";

    if(addDataService.isEditedModeStarted()){
      $scope.editMopData=addDataService.getNewMOP();
    }

    $scope.goToBalancePayments = function () {
      $state.go("account-balance");
    }

    if($scope.session && $scope.session.accountData && $scope.session.accountData.paymentMethods){
      $scope.session.accountData.paymentMethods.forEach(function(item, i) { 
        if (item.paymentMethodId == $scope.session.accountData.recentPaymentId){
          // update the list of payment methods
          AccountDataSvc.updateListMop([]);
          AccountDataSvc.setRecentPaymentMethodId("");

          $scope.updateAccountError = true;
          $rootScope.$emit("updateAccountError", $scope.updateAccountError);
        } 
      });
    }


    $rootScope.$on('mopsuccessfullyremoved', function (event, data) {
      if (data) {
        $scope.removemopmessage = data.title;
        $scope.mopremovalSuccess = data.mopremovalSuccess;
        $scope.moputoppaymentsFailed = false;
        $scope.mopinflightPaymentfailed = false;
        $scope.updateAccountError = false;
        $scope.retrievePaymentFailed = false;
      }
    })


    $scope.$on('mopinflightPaymentfailed', function (event, data) {
      if (data) {
        $scope.inflightpaymentmessage = data.title;
        $scope.mopinflightPaymentfailed = data.mopinflightPaymentfailed;
        $scope.moputoppaymentsFailed = false;
        $scope.mopremovalSuccess = false;
        $scope.updateAccountError = false;
        $scope.retrievePaymentFailed = false;
      }
    })

    $scope.$on('mopautoppaymentsFailed', function (event, data) {
      if (data) {
        $scope.mopautoppaymentmmessage = data.title;
        $scope.moputoppaymentsFailed = data.moputoppaymentsFailed;
        $scope.mopinflightPaymentfailed = false;
        $scope.mopremovalSuccess = false;
        $scope.updateAccountError = false;
        $scope.retrievePaymentFailed = false;
      }
    })

    $rootScope.$on('updateAccountError', function (event, data) {
      if (data) {
        $scope.updateAccountError = data;
        $scope.mopinflightPaymentfailed = false;
        $scope.moputoppaymentsFailed = false;
        $scope.mopremovalSuccess = false;
        $scope.updateAccountError = true;
        $scope.retrievePaymentFailed = false;
      }
    })

    $rootScope.$on('retrievePaymentsFailed', function (event, data) {
      if (data) {
        $scope.retrievepaymenterrormessage = data.title;
        $scope.retrievePaymentFailed = data.retrievePaymentFailed;
        $scope.mopinflightPaymentfailed = false;
        $scope.moputoppaymentsFailed = false;
        $scope.mopremovalSuccess = false;
        $scope.updateAccountError = false;
      }
    })

    /***
     *  DE30595: Error found in TC104212: Add card/bank acct Links not actionable with keyboard
     */ 
    $scope.goToAddcardKeys = function (event) {

      if (!event) var event = window.event;
      if (event.keyCode === 32 || event.keyCode === 49 || event.keyCode === 13) { // space or enter
        $state.go('payment-card-info');
      }
      return ; 
    }

    $scope.goToAddBankKeys = function (event) {
      //console.log(event.which);
      if (!event) var event = window.event; 
      if (event.keyCode === 32 || event.keyCode === 49 || event.keyCode === 13) { //space or enter
        $state.go('bank-account-info');
      }
      return; 
    }

    $scope.continue = function() {
      if (UserSession.registered) {
        if(UserSession.selectedPaymentMethod !== undefined  ){
          $scope.expiredIndicatorcheck = AccountDataSvc.getMopById(UserSession.selectedPaymentMethod).expiredIndicator;
        if(($scope.expiredIndicatorcheck === 'false' || $scope.expiredIndicatorcheck === false)){
        if (UserSession.paymentType === "auto") {
          log.debug(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK)+loggerServiceHelper.setStep("continueBtnClick")+loggerServiceHelper.setDescription("Navigate to automatic payment page"));
          log.debug(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD)+loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END));
          $state.go("automatic-payments");
        }else {
          log.debug(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK)+loggerServiceHelper.setStep("continueBtnClick")+loggerServiceHelper.setDescription("Navigate to review payment page"));
          log.debug(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD)+loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END));
          $state.go("review-payments");
        }
        }else{
          setTimeout(function(){
            document.getElementById('expired').focus();
            document.getElementById("expired").scrollIntoView({behavior: 'smooth'});
        }, 100);
         $scope.expiredMop = true;
         $scope.selectOfPayment= false; 
       }
       }else{
          setTimeout(function(){
            document.getElementById('banner').focus();
            document.getElementById("banner").scrollIntoView({behavior: 'smooth'});
        }, 100);
        $scope.selectOfPayment = true;
        if ($scope.session.accountData.paymentMethods.length > 0) {
          var expiredIndicatorCount = $scope.session.accountData.paymentMethods
            .map(function (item) { return item.expiredIndicator; })
            .reduce(function (acc, item) { acc[item]++; return acc; }, { true: 0, false: 0 });

          if (expiredIndicatorCount['true'] > 0){
            if (expiredIndicatorCount['false'] == 0) {
              $scope.selectOfPaymentAll = true;
            } else if (expiredIndicatorCount['false'] > 0) {
              $scope.selectOfPaymentSome = true;
            }
          }
        }
      }
    }
       else {
        /*var utagObj={
          scenario_step:'Step 3 :'+$scope.guest.mopType,
          scenario_name:'OnlinePayment:unreg:OLP',
          "tsrc":cvsUtility.queryMap.source
        };
        webAnalytics.webTrendsUtag("OBJ",utagObj,undefined,"paymentMethod");*/
        var _dest = $scope.guest.mopType === "CCARD" ? "payment-card-info" : "bank-account-info";
        log.debug(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK)+loggerServiceHelper.setStep("continueBtnClick")+loggerServiceHelper.setDescription("CARD ENTRY DETAILS"+$scope.guest.mopType));
        log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK)+loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END));
        $state.go(_dest);
      }
    };

  
    $scope.selectmop = function () {
      setTimeout(function () {
        ($('.payment-methods input')[0]).focus()
      }, 100);
    };
    $("#selectaPayment").keyup(function (event) {
      if (event.keyCode === 13) {
        $("#selectaPayment").click();
      }
    });
    $("#editexpiredcard").keyup(function (event) {
      if (event.keyCode === 13) {
        $("#editexpiredcard").click();
      }
    });
    $("#editexpired_card").keyup(function (event) {
      if (event.keyCode === 13) {
        $("#editexpired_card").click();
      }
    });

    $("#addnewcard").keyup(function (event) {
      if (event.keyCode === 13) {
        $("#addnewcard").click();
      }
    });

    $("#addnew_card").keyup(function (event) {
      if (event.keyCode === 13) {
        $("#addnew_card").click();
      }
    });

    $("#cardnew").keyup(function(event){
      if (event.keyCode === 13){
        $("#cardnew").click();
      }
    })
    $("#edit_expiredcard").keyup(function(event){
      if (event.keyCode === 13){
        $("#edit_expiredcard").click();
      }
    })
    $("#selecta_Payment").keyup(function(event){
      if (event.keyCode === 13){
        $("#selecta_Payment").click();
      }
    })
    $("#selectaPayment_expire").keyup(function(event){
      if (event.keyCode === 13){
        $("#selectaPayment_expire").click();
      }
    })
  
  $scope.expirdmop = function (){
  setTimeout(function(){
    document.getElementById('cardnew').focus();
    document.getElementById("cardnew").scrollIntoView({behavior: 'smooth'});
    // $('#cardnew ').focus()
}, 100); 
};

    $scope.checkExpiration = function(expiration) {
      if (!expiration) return false;
      return moment(expiration, "MM-YYYY").isBefore(moment.now());
    };

      $scope.editAddedMop = function(mop) {
        //$scope.session.paymentMethod=mop.paymentMethodId;
        //localStorage.clear();
        //Object.keys(userSession.persit).forEach(function(key) { delete userSession.persit[key]; });
        if(_.isEmpty(UserSession.persistCopy)){
          log.debug(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK)+loggerServiceHelper.setStep("editBtnClick")+loggerServiceHelper.setDescription("Edit button clicked for new MOP"+mop.payment.method ));
          log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK)+loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END));
        }else{
          Object.keys(userSession.persit).forEach(function(key) { delete userSession.persit[key]; });
          Object.keys(userSession.persistCopy).forEach(function(key) {  userSession.persit[key]=userSession.persistCopy[key]; });
          localStorage.clear();
          localStorage.setItem("transactionMode", "ADD");
        }
        var dest = mop.payment.method == "CHECK" ? "edit-bank-account-info" : "edit-payment-card-info";
        //$state.go(dest, { 'mopid': mop.paymentMethodId, 'editMode': false });
        $state.go(dest, { 'mopid': mop.paymentMethodId  ,'editMode': true });
      };

      log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD)+loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END)+loggerServiceHelper.setDescription("Payment method page load completed"));
  }]);
